import {makeAutoObservable} from 'mobx';
import FlashMessageStore from './FlashMessageStore';

type RootStoreInitialState = {
  redirectUrlAfterAuth: string | null;
};

const rootStoreInitialState: RootStoreInitialState = {
  redirectUrlAfterAuth: null,
};

class RootStore {
  store = rootStoreInitialState;

  flashMessageStore: FlashMessageStore;

  constructor() {
    makeAutoObservable(this);
    this.flashMessageStore = new FlashMessageStore(this);
  }

  setRedirectUrlAfterAuth = (redirectUrlAfterAuth: string | null) => {
    this.store.redirectUrlAfterAuth = redirectUrlAfterAuth;
  };

  get redirectUrlAfterAuth() {
    return this.store.redirectUrlAfterAuth;
  }
}

export default RootStore;
